import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiFragment } from '@stylehaven/components';

@Injectable()
export abstract class MiddlewareService {
    abstract annotate(record: ApiFragment): Observable<ApiFragment>;
}
